module.exports = __webpack_public_path__ + "img/bi-marketplace-1.0cd5dbfc.png";